import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../ui/select";
import { Checkbox } from "../ui/checkbox";
import { INTERESTS, KM } from "../../data/km";

const field = "w-full bg-transparent border-b border-black/25 py-3.5 text-base sm:text-[15px] outline-none focus:border-black transition-colors placeholder:text-black/50";
const empty = { name: "", email: "", phone: "", interest: "", message: "", consent: false };

// MOCKED: submissions are stored in localStorage only (no backend yet)
export default function ContactForm({ interest = "" }) {
  const [f, setF] = useState({ ...empty, interest });
  const [sent, setSent] = useState(false);
  useEffect(() => { setF((p) => ({ ...p, interest: interest || p.interest })); }, [interest]);
  const set = (k) => (e) => setF({ ...f, [k]: e?.target ? e.target.value : e });

  const submit = (e) => {
    e.preventDefault();
    if (!f.name.trim() || !/^\S+@\S+\.\S+$/.test(f.email)) return toast.error("Please add your name and a valid email.");
    if (!f.consent) return toast.error("Please agree to be contacted.");
    const all = JSON.parse(localStorage.getItem("km_leads") || "[]");
    all.push({ ...f, at: new Date().toISOString() });
    localStorage.setItem("km_leads", JSON.stringify(all));
    setSent(true);
    toast.success("Thank you — Kristin will be in touch soon.");
    setF(empty);
  };

  if (sent)
    return (
      <div className="py-10" data-testid="contact-success">
        <p className="km-serif italic text-[28px] text-[#2C4A3B] mb-4">Thank you.</p>
        <p className="km-body text-[#141414] mb-8">Your message is on its way. Expect a reply within one business day.</p>
        <button className="km-btn-outline" onClick={() => setSent(false)} data-testid="contact-send-another">Send another</button>
      </div>
    );

  return (
    <form onSubmit={submit} className="space-y-4" data-testid="contact-form">
      <input className={field} placeholder="Name" value={f.name} onChange={set("name")} data-testid="contact-name" />
      <div className="grid sm:grid-cols-2 gap-x-6 gap-y-4">
        <input className={field} placeholder="Email" value={f.email} onChange={set("email")} data-testid="contact-email" />
        <input className={field} placeholder="Phone" value={f.phone} onChange={set("phone")} data-testid="contact-phone" />
      </div>
      <Select value={f.interest} onValueChange={set("interest")}>
        <SelectTrigger className="rounded-none border-0 border-b border-black/25 px-0 h-auto py-3.5 shadow-none focus:ring-0 text-base sm:text-[15px] data-[placeholder]:text-black/50" data-testid="contact-interest"><SelectValue placeholder="I'm interested in..." /></SelectTrigger>
        <SelectContent>{INTERESTS.map((i) => <SelectItem key={i} value={i}>{i}</SelectItem>)}</SelectContent>
      </Select>
      <textarea rows={4} className={field} placeholder="Tell me a little about your home or your search" value={f.message} onChange={set("message")} data-testid="contact-message" />
      <label className="flex gap-3 items-start text-[12px] leading-relaxed text-[#141414] cursor-pointer pt-2">
        <Checkbox checked={f.consent} onCheckedChange={set("consent")} className="mt-0.5" data-testid="contact-consent" />
        <span>I agree to be contacted by {KM.name} via call, email, and text for real estate services. Reply STOP to opt out. Message and data rates may apply.</span>
      </label>
      <button type="submit" className="km-btn-dark mt-4" data-testid="contact-submit">Send Message</button>
    </form>
  );
}
